<template>
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />

    <!-- input content -->

    <b-collapse
      class="card mt-5"
      id="collapse-1"
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      v-model="collapse"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional=='1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <div class="mt-3" :id="fieldData.id">
        <h4>{{fieldData.label[selectedLanguage]}}</h4>
        <p>{{fieldData.description[selectedLanguage]}}</p>
        <b-form-checkbox id="checkbox-na" v-show="!fieldData.isNaFeature || fieldData.isNaFeature == 0" v-model="fieldData.isNa" value="1" unchecked-value="0">N/A</b-form-checkbox>
      </div>
      <b-modal
        v-model="showAddRowModal"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        :title="isUpdtating ?  $t('workflow.update')+' '+fieldData.label[selectedLanguage] : $t('workflow.add')+' '+fieldData.label[selectedLanguage]"
        size="xl"
      >
        <div class="card-body text-left">
          <!-- <h3>Individual Shareholders</h3> -->
          <div class="form-row" :id="fieldData.id">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.firstNameDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.firstNameHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssFirstName ? $t('createProfile.invalidInputMessage') : fieldData.firstNameValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireFirstName)"
                    class="required-span"
                  >*</span>
                  {{fieldData.firstNameLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.form.firstName.$model"
                  @input="checkXss('xssFirstName', $event)"
                  :placeholder="
                    fieldData.firstNamePlaceholderText[selectedLanguage]
                  "
                  :state="
                    msg.xssFirstName
                      ? false
                      : $v.form && $v.form.firstName.$dirty
                      ? !$v.form.firstName.$error
                      : null
                  "
                ></b-form-input>
              </b-form-group>
            </div>

            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.lastNameDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.lastNameHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssLastName ? $t('createProfile.invalidInputMessage') : fieldData.lastNameValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireLastName)"
                    class="required-span"
                  >*</span>
                  {{fieldData.lastNameLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  :disabled="isDisabled == 1"
                  type="text"
                  v-model="$v.form.lastName.$model"
                  @input="checkXss('xssLastName', $event)"
                  :placeholder="
                    fieldData.lastNamePlaceholderText[selectedLanguage]
                  "
                  :state="
                    msg.xssLastName
                      ? false
                      : $v.form && $v.form.lastName.$dirty
                      ? !$v.form.lastName.$error
                      : null
                  "
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.dateOfBirthDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.dateOfBirthHelperText[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireDateOfBirth)"
                    class="required-span"
                  >*</span>
                  {{fieldData.dateOfBirthLabel[selectedLanguage]}}
                </label>
                <b-input-group :class="$store.state.rightAlign ? 'text-right' : 'text-left'">
                  <Datepicker
                    :disabled="isDisabled == 1"
                    input-class="custom-date-picker"
                    calendar-class="date-calender"
                    class="form-control"
                    :class="$v.form.dateOfBirth.$error ? 'border border-danger rounded' : null"
                    v-model="$v.form.dateOfBirth.$model"
                    :format="customDateFormat"
                    :disabled-dates="disabledDates"
                    :state="$v.form && $v.form.dateOfBirth.$dirty ? !$v.form.dateOfBirth.$error : null"
                  ></Datepicker>
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                </b-input-group>
                <label
                  v-if="$v.form.dateOfBirth.$error && fieldData.validation.isRequireDateOfBirth && !form.dateOfBirth"
                  class="text-danger"
                  style="font-size: 80%;"
                >{{fieldData.dateOfBirthValidationMessage[selectedLanguage]}}</label>
              </b-form-group>
            </div>

            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.percentageOwnedDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.percentageOwnedHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssPercentageOwned ? $t('createProfile.invalidInputMessage') : fieldData.percentageOwnedValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequirePercentageOwned)"
                    class="required-span"
                  >*</span>
                  {{fieldData.percentageOwnedLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  onkeydown="return event.keyCode !== 69"
                  :disabled="isDisabled == 1"
                  min="1"
                  max="100"
                  v-model="$v.form.percentageOwned.$model"
                  @input="checkXss('xssPercentageOwned', $event)"
                  :placeholder="fieldData.percentageOwnedPlaceholderText[selectedLanguage]"
                  :state="
                    msg.xssPercentageOwned
                      ? false
                      : $v.form && $v.form.percentageOwned.$dirty
                      ? !$v.form.percentageOwned.$error
                      : null
                  "
                  type="number"
                  onpaste="return false;"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.countryOfBirthDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.countryOfBirthHelperText[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireCountryOfBirth)"
                    class="required-span"
                  >*</span>
                  {{fieldData.countryOfBirthLabel[selectedLanguage]}}
                </label>
                <v-select
                  :disabled="isDisabled == 1"
                  :searchable="true"
                  :clearable="true"
                  label="name"
                  :class="$v.form.countryOfBirth.$error ? 'border border-danger rounded' : null"
                  v-model="$v.form.countryOfBirth.$model"
                  :state="$v.form && $v.form.countryOfBirth.$dirty ? !$v.form.countryOfBirth.$error : null"
                  :options="optionsCountries"
                  @input="onSelected"
                >
                  <template slot="option" slot-scope="option">
                    <country-flag v-if="option.icon" :country="option.icon" size="small" />
                    <span>{{ '&nbsp;'+ option.name }}</span>
                  </template>
                </v-select>
                <label
                  v-if="$v.form.countryOfBirth.$error && fieldData.validation.isRequireCountryOfBirth && !form.countryOfBirth"
                  class="text-danger"
                  style="font-size: 80%;"
                >{{fieldData.countryOfBirthValidationMessage[selectedLanguage]}}</label>
              </b-form-group>
            </div>

            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.passportNumberDisabled"
            >
              <b-form-group
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                :description="fieldData.passportNumberHelperText[selectedLanguage]"
                :invalid-feedback="msg.xssPassportNumber ? $t('createProfile.invalidInputMessage') : fieldData.passportNumberValidationMessage[selectedLanguage]"
              >
                <label>
                  <span
                    v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequirePassportNumber)"
                    class="required-span"
                  >*</span>
                  {{fieldData.passportNumberLabel[selectedLanguage]}}
                </label>
                <b-form-input
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  :disabled="isDisabled == 1"
                  min="1"
                  max="100"
                  v-model="$v.form.passportNumber.$model"
                  @input="checkXss('xssPassportNumber', $event)"
                  :placeholder="
                    fieldData.passportNumberPlaceholderText[selectedLanguage]
                  "
                  :state="
                    msg.xssPassportNumber
                      ? false
                      : $v.form && $v.form.passportNumber.$dirty
                      ? !$v.form.passportNumber.$error
                      : null
                  "
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

          <!-- freee form field -->
          <div class="form-row">
            <div
              class="col-md-6"
              v-show="!fieldData.advance || !fieldData.advance.freeFormDisabled"
            >
              <div v-if="fieldData.freeFormLabel">
                <b-form-group
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  :description="fieldData.freeFormHelperText[selectedLanguage] || ''"
                  :invalid-feedback="msg.xssFreeForm ? $t('createProfile.invalidInputMessage') : fieldData.freeFormValidationMessage[selectedLanguage] || ''"
                >
                  <label class="text-left">
                    <span
                      v-if="fieldData.validation && JSON.parse(fieldData.validation.isRequireFreeForm)"
                      class="required-span"
                    >*</span>
                    {{fieldData.freeFormLabel[selectedLanguage] || ''}}
                  </label>
                  <b-form-input
                    :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                    :disabled="isDisabled == 1"
                    type="text"
                    v-model="$v.form.freeForm.$model"
                    @input="checkXss('xssFreeForm', $event)"
                    :placeholder="
                      fieldData.freeFormPlaceholderText[selectedLanguage] || ''
                    "
                    :state="
                      msg.xssFreeForm
                        ? false
                        : $v.form && $v.form.freeForm.$dirty
                        ? !$v.form.freeForm.$error
                        : null
                    "
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <template v-slot:modal-footer>
          <b-button variant="danger" @click="resetModal">{{$t('closeBtnText')}}</b-button>
          <b-button
            variant="success"
            @click="isUpdtating ? updateRow() : addRow()"
          >{{ isUpdtating ? $t('updateBtn') : $t('saveBtnText') }}</b-button>
        </template>
      </b-modal>

      <b-row>
        <!-- @click="updateRow" -->

        <b-col cols="12" v-if="taskStatus != 4">
          <!-- <b-button
            v-if="isUpdtating"
            :disabled="isDisabled == 1"
            class="mr-2"
            @click="showAddRowModal = !showAddRowModal"
          >{{$t('workflow.update')}}</b-button>-->
          <b-button
            :disabled="isDisabled == 1 || fieldData.isNa == 1"
            class="mr-2 mt-2"
            variant="outline-success"
            size="lg"
            @click="showAddRowModal = !showAddRowModal"
          >
            <font-awesome-icon icon="plus" />
            {{$t('workflow.add')}}
          </b-button>

          <!-- <b-button
            :disabled="isDisabled == 1"
            variant="warning"
            @click="reset"
          >{{$t('workflow.reset')}}</b-button>-->
        </b-col>
      </b-row>

      <!-- v-if="items.length > 0" -->
      <b-row class="mt-3">
        <b-col cols="12" class="p-5">
          <b-table-simple striped hover>
            <b-thead>
              <b-tr>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.firstNameDisabled"
                >{{fieldData.firstNameLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.lastNameDisabled"
                >{{fieldData.lastNameLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.dateOfBirthDisabled"
                >{{fieldData.dateOfBirthLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.percentageOwnedDisabled"
                >{{fieldData.percentageOwnedLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.countryOfBirthDisabled"
                >{{fieldData.countryOfBirthLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.passportNumberDisabled"
                >{{fieldData.passportNumberLabel[selectedLanguage]}}</b-th>
                <b-th
                  v-if="!fieldData.advance || !fieldData.advance.freeFormDisabled"
                >{{fieldData.freeFormLabel && fieldData.freeFormLabel[selectedLanguage]}}</b-th>
                <b-th>{{$t('upload.fileAction')}}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-for="(item, index) in items" :key="index">
              <b-tr>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.firstNameDisabled"
                >{{item.first_name || ''}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.lastNameDisabled"
                >{{item.last_name || ''}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.dateOfBirthDisabled"
                >{{format_date(item.date_of_birth)}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.percentageOwnedDisabled"
                >{{item.percentage_owned || ''}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.countryOfBirthDisabled"
                >{{item.country_of_birth && item.country_of_birth.name || ''}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.passportNumberDisabled"
                >{{item.passport_port || ''}}</b-td>
                <b-td
                  v-if="!fieldData.advance || !fieldData.advance.freeFormDisabled"
                >{{item.free_form || ''}}</b-td>
                <b-td>
                  <b-button @click="onEditRow(item,index)" size="sm" class="mr-1">
                    <font-awesome-icon :icon="taskStatus != 4 ? 'edit' : 'eye'" />
                  </b-button>
                  <b-button
                    @click="onDeleteRow(index)"
                    variant="danger"
                    size="sm"
                    v-if="taskStatus != 4"
                  >
                    <font-awesome-icon icon="trash" />
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-collapse>

    <!-- show advance field options -->
    <b-modal
      cancel-title="Close"
      ok-title="save"
      @ok="onSaveData"
      size="xl"
      v-model="showSettings"
      scrollable
      title="Advanced Settings"
    >
      <AdvanceSettings
        :fieldData="fieldData"
        v-on:toggle-field="showSettings=!showSettings"
        :sectionIndex="sectionIndex"
        :fieldIndex="fieldIndex"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import MenuButtons from "../menuButtons";
import AdvanceSettings from "../workflowSettings/advanceIndividualShareHoldersSettings.vue";
import { FiltersCountries, Helper, Validate } from "../../helpers";
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { EventBus } from "@/event-bus.js";
import CountryCodes from "../../utils/countryCodes.json";
import { required, minLength } from "vuelidate/lib/validators";
import moment from "moment";
import "moment/locale/es";
import Datepicker from "vuejs-datepicker";

export default {
  name: "IndividualShareholderGroup",
  mixins: [validationMixin],
  components: {
    MenuButtons,
    vSelect,
    AdvanceSettings,
    Datepicker,
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
  },
  data() {
    return {
      showFreeForm: false,
      showAddRowModal: false,
      items: [],
      isHidden: false,
      condition: {},
      title: null,
      optionsCountries: CountryCodes.countries,
      form: {
        firstName: null,
        lastName: null,
        percentageOwned: null,
        dateOfBirth: null,
        countryOfBirth: null,
        passportNumber: null,
        freeForm: null,
      },
      label: null,
      showSettings: false,
      collapse: true,
      isUpdtating: false,
      selectedRowIndex: null,
      msg: {},
      postData: [],
      taskStatus: 0,
      selectedRow: null,
      disabledDates: {
        to:
          this.fieldData.advanceDate &&
          this.fieldData.advanceDate.disabledMinDateInput
            ? new Date(Date.now() - 864e5)
            : this.fieldData.advanceDate && this.fieldData.advanceDate.minDate
            ? new Date(this.fieldData.advanceDate.minDate)
            : "", // Disable all dates up to specific date
        from:
          this.fieldData.advanceDate &&
          this.fieldData.advanceDate.disabledMaxDateInput
            ? new Date()
            : this.fieldData.advanceDate && this.fieldData.advanceDate.maxDate
            ? new Date(this.fieldData.advanceDate.maxDate)
            : "", // Disable all dates after specific date
      },
    };
  },

  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress" || this.fieldData.isNa == 1) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.setDataToUser();
      } else {
        let validations = Object.values(this.fieldData.validation);
        const found = validations.find((value) => value == true);
        if (
          (this.items && this.items.length > 0) ||
          this.fieldData.isHidden ||
          found == undefined
        ) {
          this.setDataToUser();
          this.$store.state.validFields = true;
          this.fieldData.isInValid = false;
        } else {
          this.$store.state.validFields = false;
          this.fieldData.isInValid = true;
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id)
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  mounted() {
    this.setNewConditions();
    this.setFreeFormFields();
    this.checkForConditional();
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.getDataForUser();
    }
    let st = parseInt(localStorage.getItem("activeTaskStatus"));
    this.taskStatus = st;
  },

  validations() {
    return {
      form: {
        firstName: {
          [this.firstName]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireFirstName
              ? required
              : !required,
        },
        lastName: {
          [this.lastName]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireLastName
              ? required
              : !required,
        },
        percentageOwned: {
          [this.percentageOwned]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequirePercentageOwned
              ? required
              : !required,
        },
        dateOfBirth: {
          [this.dateOfBirth]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireDateOfBirth
              ? required
              : !required,
        },

        countryOfBirth: {
          [this.countryOfBirth]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireCountryOfBirth
              ? required
              : !required,
        },

        passportNumber: {
          [this.passportNumber]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequirePassportNumber
              ? required
              : !required,
        },

        freeForm: {
          [this.freeForm]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireFreeForm
              ? required
              : !required,
        },
      },
    };
  },
  methods: {
    setFreeFormFields() {
      if (this.fieldData.freeFormLabel == undefined) {
        Object.assign(this.fieldData, {
          freeFormLabel: {
            english: "Free Form",
          },
          freeFormPlaceholderText: {
            english: "",
          },
          freeFormHelperText: {
            english: "",
          },
          freeFormValidationMessage: {
            english: "This field is required",
          },
        });
        let validation = {
          ...this.fieldData.validation,
          isRequireFreeForm:
            this.fieldData.validation.isRequireFreeForm || false,
        };
        Object.assign(this.fieldData, { validation });
        let advance = {
          ...this.fieldData.advance,
          freeFormDisabled: this.fieldData.advance.freeFormDisabled || true,
        };
        Object.assign(this.fieldData, { advance });
      }

      // this.showFreeForm = true;
    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },

    customDateFormat(value) {
      let customFormat = this.fieldData.format;
      if (customFormat == "default") {
        return moment(value).format("DD-MM-YYYY");
      } else {
        return moment(value).format(customFormat);
      }
    },

    setNewConditions() {
      Object.assign(this.fieldData, {
        isInValid: this.fieldData.isInValid || null,
      });
      Object.assign(this.fieldData, {
        isHidden: this.fieldData.isHidden || false,
      });
      Object.assign(this.fieldData, {
        isConditional: this.fieldData.isConditional || 0,
      });
      Object.assign(this.fieldData, {
        conditions:
          this.fieldData.conditions && this.fieldData.conditions.length
            ? this.fieldData.conditions
            : [],
      });
      Object.assign(this.fieldData, {
        conditionalFields:
          this.fieldData.conditionalFields &&
          this.fieldData.conditionalFields.length
            ? this.fieldData.conditionalFields
            : [],
      });
      Object.assign(this.fieldData, {
        sectionConditions:
          this.fieldData.sectionConditions &&
          this.fieldData.sectionConditions.length
            ? this.fieldData.sectionConditions
            : [],
      });
    },

    onSelected(value) {
      this.countryOfBirth = value.name;
    },

    checkXss(key, value) {
      this.msg[key] = !Validate.noXSS(value) ? true : false;
    },

    hasUnsafeInput() {
      return (
        !Validate.noXSS(this.form.firstName) ||
        !Validate.noXSS(this.form.lastName) ||
        !Validate.noXSS(this.form.passportNumber) ||
        !Validate.noXSS(this.form.freeForm) ||
        !Validate.noXSS(this.form.percentageOwned)
      );
    },

    resetModal() {
      (this.form.firstName = null),
        (this.form.lastName = null),
        (this.form.dateOfBirth = null),
        (this.form.percentageOwned = null),
        (this.form.countryOfBirth = null);
      this.form.passportNumber = null;
      this.form.freeForm = null;
      this.msg = {};
      this.$v.$reset();
      this.showAddRowModal = false;
    },

    addRow() {
      const registerData = _.clone(this.$store.state.registerData);
      this.$v.form.$touch();
      if (this.$v.form.$anyError && this.$v.form.$invalid) {
        return;
      }
      if (this.hasUnsafeInput()) {
        return;
      }
      this.overallInvalid = false;
      registerData[this.fieldData.id] = "individual-shareholders";
      this.$store.state.registerData = registerData;

      // main calculations :p
      const numkeys = Object.keys(registerData).length;
      // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
      this.$store.state.progressValue = numkeys;

      let row = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        date_of_birth: this.form.dateOfBirth,
        percentage_owned: this.form.percentageOwned,
        country_of_birth: this.form.countryOfBirth,
        passport_port: this.form.passportNumber,
        free_form: this.form.freeForm,

        actions: "&nbsp;",
      };
      this.resetModal();
      // // console.log("this.$route", this.$route)
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        let aa = [
          {
            postValue: row.first_name || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.firstNamePostName) ||
              "firstNamePost",
            key: "first_name",
            label: this.fieldData.firstNameLabel[this.selectedLanguage],
          },
          {
            postValue: row.last_name || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.lastNamePostName) ||
              "lasNamePost",
            key: "last_name",
            label: this.fieldData.lastNameLabel[this.selectedLanguage],
          },
          {
            postValue: row.date_of_birth || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.dateOfBirthPostName) ||
              "dobPost",
            key: "date_of_birth",
            label: this.fieldData.dateOfBirthLabel[this.selectedLanguage],
          },
          {
            postValue: row.percentage_owned || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.percentageOwnedPostName) ||
              "percentageOwnedPost",
            key: "percentage_owned",
            label: this.fieldData.percentageOwnedLabel[this.selectedLanguage],
          },
          {
            postValue: row.country_of_birth || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.countryOfBirthPostName) ||
              "countryOfBirthPost",
            key: "country_of_birth",
            label: this.fieldData.countryOfBirthLabel[this.selectedLanguage],
          },
          {
            postValue: row.passport_port || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.passportNumberPostName) ||
              "passportNumberPost",
            key: "passport_port",
            label: this.fieldData.passportNumberLabel[this.selectedLanguage],
          },
          {
            postValue: row.free_form || "",
            postName:
              (this.fieldData.attributes &&
                this.fieldData.attributes.freeFormPostName) ||
              "freeFormPost",
            key: "free_form",
            label: this.fieldData.freeFormLabel[this.selectedLanguage],
          },
        ];
        // if (row.country_of_birth) {
        this.postData.push(aa);
        this.items.push(row);
        // }
      }
    },

    getDataForUser() {
      this.$store.state.getUserFormSubmitArray.map((data) => {
        if (data.elements && data.elements.length > 0) {
          data.elements.map((element, index) => {
            if (data.elementId === this.fieldData.id) {
              this.fieldData.isNa = data.isWorkFlowNa
              console.log("Individual shareholders data foondt --------------");
              let row = {
                first_name:
                  element[element.findIndex((x) => x.key == "first_name")]
                    .postValue,
                last_name:
                  element[element.findIndex((x) => x.key == "last_name")]
                    .postValue,
                date_of_birth:
                  element[element.findIndex((x) => x.key == "date_of_birth")]
                    .postValue,
                percentage_owned:
                  element[element.findIndex((x) => x.key == "percentage_owned")]
                    .postValue,
                country_of_birth:
                  element[element.findIndex((x) => x.key == "country_of_birth")]
                    .postValue,
                passport_port:
                  element[element.findIndex((x) => x.key == "passport_port")]
                    .postValue,
                // free_form:element[element.findIndex(x => x.key == "free_form")].postValue,

                actions: "&nbsp;",
              };
              // this.fieldData.isHidden = el.postValue.length ? false: true
              this.items.push(row);
              this.postData = data.elements;
            }
          });
        }
      });
    },

    setDataToUser(row) {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            console.log("found individual");
            a.isWorkFlowNa = this.fieldData.isNa
            a.elements = this.postData;
          }
        });
      }
    },

    updateRow() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError && this.$v.form.$invalid) {
        return;
      }
      if (this.hasUnsafeInput()) {
        return;
      }
      this.overallInvalid = false;
      this.items[this.selectedRowIndex].first_name = this.form.firstName;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "first_name"
        )
      ].postValue = this.form.firstName;

      this.items[this.selectedRowIndex].last_name = this.form.lastName;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "last_name"
        )
      ].postValue = this.form.lastName;

      this.items[this.selectedRowIndex].date_of_birth = this.form.dateOfBirth;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "date_of_birth"
        )
      ].postValue = this.form.dateOfBirth;

      this.items[
        this.selectedRowIndex
      ].percentage_owned = this.form.percentageOwned;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "percentage_owned"
        )
      ].postValue = this.form.percentageOwned;

      this.items[
        this.selectedRowIndex
      ].country_of_birth = this.form.countryOfBirth;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "country_of_birth"
        )
      ].postValue = this.form.countryOfBirth;

      this.items[
        this.selectedRowIndex
      ].passport_port = this.form.passportNumber;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "passport_port"
        )
      ].postValue = this.form.passportNumber;

      this.items[this.selectedRowIndex].free_form = this.form.freeForm;
      this.postData[this.selectedRowIndex][
        this.postData[this.selectedRowIndex].findIndex(
          (x) => x.key == "free_form"
        )
      ].postValue = this.form.freeForm;

      this.isUpdtating = false;
      this.resetModal();
    },

    onDeleteRow(index) {
      const registerData = _.clone(this.$store.state.registerData);
      if (this.items.length == 1 && this.postData.length == 1) {
        delete registerData[this.fieldData.id];
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;
      }
      this.postData.splice(index, 1);
      this.items.splice(index, 1);
    },

    onEditRow(item, index) {
      this.isUpdtating = true;
      this.selectedRowIndex = index;
      this.showAddRowModal = true;
      this.form = {
        firstName: item.first_name,
        lastName: item.last_name,
        dateOfBirth: item.date_of_birth,
        percentageOwned: item.percentage_owned,
        countryOfBirth: item.country_of_birth,
        passportNumber: item.passport_port,
        freeForm: item.free_form,
      };
    },

    setValidation() {
      let validation = {
        isRequireFirstName: true,
        isRequireLastName: true,
        isRequireDateOfBirth: true,
        isRequirePercentageOwned: true,
        isRequirePassportNumber: true,
        isRequireCountryOfBirth: true,
      };
      Object.assign(this.fieldData, { validation });
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      this.onRerenerView();
      Helper.makeToast(this.$bvToast, "success", "Settings updated");
    },

    onRerenerView() {
      this.$store.state.isLoading = true;
      setTimeout(() => {
        this.$store.state.isLoading = false;
      }, 50);
    },

    checkForConditional() {
      // // console.log("checkForConditional", this.fieldData)
      if (this.fieldData.isConditional == 1) {
        this.fieldData.isHidden = true;
      }
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>

<style>
.v-select-toggle[data-v-138dff1d] {
  border: 1px solid #d3d9df;
  background-color: white;
  height: 40px;
}

.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: #e9ecef !important;
  border: 1px solid #ced4da !important;
  height: 40px;
}
.custom-date-picker {
  width: 100%;
  border: none;
}
.custom-date-picker:focus {
  border: none;
}
.date-calender {
  width: 350px !important;
  background: #dee2e6 !important;
}
</style>
